import { useState } from "react";
import Api from "../../api/Api";

export default function ForgotPasswordModal({ isOpen, onClose, onSubmit }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  

  if (!isOpen) return null;

  const validateEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateEmail(email)) {
      setError("Introduz um email válido.");
      return;
    }
    setError("");
    setLoading(true);
    // Simula chamada à API
   
const response =await Api.recoverPassword({email:email});

if(response.status=420){
setError("Conta inexistente");
}
  if(response.status=423){
setError("Conta bloqueada");
}
if(response.success){
  
  setSent(true);
}



    setLoading(false);
  
  
  };







  const handleClose = () => {
    setEmail("");
    setSent(false);
    setError("");
    onClose();
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

        .modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(2, 11, 26, 0.72);
          backdrop-filter: blur(6px);
          -webkit-backdrop-filter: blur(6px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          font-family: 'Inter', sans-serif;
          animation: overlayFade 0.25s ease;
        }

        @keyframes overlayFade {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        .fp-modal {
          background: #ffffff;
          border-radius: 20px;
          width: min(420px, 92vw);
          padding: 40px 36px;
          position: relative;
          box-shadow: 0 32px 80px rgba(0,0,0,0.5), 0 0 0 1px rgba(0,174,255,0.1);
          animation: modalPop 0.35s cubic-bezier(.22,1,.36,1);
        }

        @keyframes modalPop {
          from { opacity: 0; transform: translateY(20px) scale(0.96); }
          to   { opacity: 1; transform: translateY(0) scale(1); }
        }

        .fp-close {
          position: absolute;
          top: 18px;
          right: 18px;
          background: #f5f9fd;
          border: none;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: #8aa0b6;
          transition: background 0.2s, color 0.2s;
        }
        .fp-close:hover { background: #e2eaf0; color: #1a2b3c; }

        .fp-icon-wrap {
          width: 64px;
          height: 64px;
          border-radius: 18px;
          background: linear-gradient(135deg, #00aaff 0%, #0044ee 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 22px;
          box-shadow: 0 10px 28px rgba(0,100,255,0.35);
        }

        .fp-title {
          font-size: 1.4rem;
          font-weight: 700;
          color: #0d1b2a;
          text-align: center;
          margin-bottom: 8px;
          letter-spacing: -0.02em;
        }

        .fp-subtitle {
          font-size: 0.85rem;
          color: #7a8fa6;
          text-align: center;
          margin-bottom: 28px;
          line-height: 1.5;
        }

        .fp-input-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          margin-bottom: 8px;
        }

        .fp-input-icon {
          position: absolute;
          left: 16px;
          color: #9ab0c8;
          pointer-events: none;
          display: flex;
          align-items: center;
        }

        .fp-input {
          width: 100%;
          height: 50px;
          padding: 0 16px 0 46px;
          border-radius: 12px;
          border: 1.5px solid #e2eaf0;
          background: #f5f9fd;
          font-size: 0.9rem;
          color: #1a2b3c;
          font-family: 'Inter', sans-serif;
          outline: none;
          transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
        }

        .fp-input::placeholder { color: #a8bfcf; }

        .fp-input:focus {
          border-color: #0090e7;
          background: #fff;
          box-shadow: 0 0 0 3px rgba(0,144,231,0.12);
        }

        .fp-input.fp-error {
          border-color: #ef4444;
        }

        .fp-error-text {
          font-size: 0.78rem;
          color: #ef4444;
          margin-bottom: 18px;
          padding-left: 4px;
        }

        .fp-btn {
          width: 100%;
          height: 52px;
          border-radius: 12px;
          border: none;
          cursor: pointer;
          font-size: 0.95rem;
          font-weight: 600;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          color: #fff;
          background: linear-gradient(135deg, #00aaff 0%, #0044ee 100%);
          box-shadow: 0 6px 24px rgba(0,100,255,0.35);
          transition: transform 0.18s, box-shadow 0.18s, filter 0.18s, opacity 0.18s;
          font-family: 'Inter', sans-serif;
          margin-top: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
        }

        .fp-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 10px 32px rgba(0,100,255,0.5);
          filter: brightness(1.08);
        }

        .fp-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .fp-spinner {
          width: 16px;
          height: 16px;
          border: 2px solid rgba(255,255,255,0.4);
          border-top-color: #fff;
          border-radius: 50%;
          animation: spin 0.7s linear infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        .fp-back-link {
          text-align: center;
          margin-top: 18px;
        }

        .fp-back-link button {
          background: none;
          border: none;
          color: #0077cc;
          font-size: 0.82rem;
          font-weight: 500;
          cursor: pointer;
          font-family: 'Inter', sans-serif;
        }
        .fp-back-link button:hover { text-decoration: underline; }

        /* Success state */
        .fp-success-icon {
          width: 72px;
          height: 72px;
          border-radius: 50%;
          background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 22px;
          box-shadow: 0 10px 28px rgba(34,197,94,0.35);
          animation: successPop 0.5s cubic-bezier(.22,1,.36,1);
        }

        @keyframes successPop {
          0% { transform: scale(0); }
          60% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }

        .fp-success-email {
          font-weight: 600;
          color: #0d1b2a;
        }
      `}</style>

      <div className="modal-overlay" onClick={handleClose}>
        <div className="fp-modal" onClick={e => e.stopPropagation()}>
          <button className="fp-close" onClick={handleClose} aria-label="Fechar">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>

          {!sent ? (
            <>
              <div className="fp-icon-wrap">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
              </div>

              <div className="fp-title">Recuperar Palavra-passe</div>
              <div className="fp-subtitle">
                Introduz o teu email e enviaremos um link para criares uma nova palavra-passe.
              </div>

              <form onSubmit={handleSubmit}>
                <div className="fp-input-wrapper">
                  <span className="fp-input-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="2" y="4" width="20" height="16" rx="2"/>
                      <path d="m22 7-10 7L2 7"/>
                    </svg>
                  </span>
                  <input
                    type="email"
                    className={`fp-input ${error ? "fp-error" : ""}`}
                    placeholder="O teu email"
                    value={email}
                    onChange={e => { setEmail(e.target.value); setError(""); }}
                    autoFocus
                  />
                </div>
                {error && <div className="fp-error-text">{error}</div>}

                <button type="submit" className="fp-btn" disabled={loading}>
                  {loading && <span className="fp-spinner" />}
                  {loading ? "A enviar..." : "Enviar link"}
                </button>
              </form>

              <div className="fp-back-link">
                <button type="button" onClick={handleClose}>Voltar ao login</button>
              </div>
            </>
          ) : (
            <>
              <div className="fp-success-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              </div>
              <div className="fp-title">Email enviado!</div>
              <div className="fp-subtitle">
                Enviámos um link de recuperação para <span className="fp-success-email">{email}</span>.
                Verifica a tua caixa de entrada.
              </div>
              <button className="fp-btn" onClick={handleClose}>
                Voltar ao login
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
}